import React, { useEffect, useState } from 'react'
import { updateusernameProps } from './updateusername-inteface'
import { Alert, Button, Form, Input, Modal } from 'antd'
import { openNotificationWithIcon } from '../../../utils/helper'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/store'
import { upateUserUserName } from '../../../api/user/user'
import { updateUser } from '../../../store/userSlice/userSlice'


const Updateusername = ({ open, closeModal, handleReload }: updateusernameProps) => {


  const [form] = Form.useForm();
  const dispatch = useDispatch()


  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<any>(null)
  const [errors, setErrors] = useState({
    userName: '',
  })

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }))

  const { user } = state


  const onFinish = async (values: any) => {
    try {
      setLoading(true)
      setError(null)
      setErrors(prevState => ({
        ...prevState,
        userName: '',
      }))

      if (values.userName === user?.userName) {
        openNotificationWithIcon("success", "Update Username", "Username updated successfully")

      } else {
        const res = await upateUserUserName({
          ...values,
        })

        const { message } = res.data

        dispatch(updateUser({
          user: {
            ...user,
            userName: values.userName
          }
        }))

        openNotificationWithIcon("success", "Update Username", message)
        handleReload && handleReload()
      }

      setLoading(false)
      closeModal()

    } catch (error: any) {
      setLoading(false)
      const otherErrors: any[] = []
      if (error?.response) {
        if (error?.response?.data?.errors) {
          const resError = error?.response?.data?.errors

          Object.entries(resError).forEach(([key, value]) => {
            if (Object.keys(errors).includes(key)) {
              setErrors(prevState => ({
                ...prevState,
                [key]: value
              }))
            } else {
              otherErrors.push(value)
            }
          })

          if (otherErrors.length > 0) {
            const errorList = otherErrors.map((element: any, index) => {
              return <li key={`error-list-${index}`}>{element}</li>
            });
            setError(errorList)
          }

        } else {
          setError(error?.response?.data?.message || 'Something went wrong')
        }
      } else {
        setError('Something went wrong')
      }
    }
  }

  useEffect(() => {
    form.setFieldValue('userName', user?.userName)
  }, [user, form])

  return (
    <div>
      <Modal
        closable={false}
        open={open}
        onOk={() => {
          if (!loading) {
            closeModal()
          }
        }}
        onCancel={() => {
          if (!loading) {
            closeModal()
          }
        }}
        footer={null}
        width={'38rem'}
        className='white-bg-modal'
      >
        <div>
          <div className='flex border-b border-appcolorgreyfour pb-[0.75rem] justify-between items-center'>
            <h1 className='text-[22px] leading-[110%] font-semibold text-appcolorgrey mb-[-1rem]'>Update Username</h1>
            <div className='rounded-full bg-appcolorgreyfive custom-box-shadow-five p-[0.9rem] w-fit cursor-pointer'
              onClick={() => {
                if (!loading) {
                  closeModal()
                }
              }}
            >
              <img src="/img/vectors/modalclose.svg" alt="" />
            </div>
          </div>

          <div className='mt-[2rem]'>
            {
              error !== null ?
                <div className='mb-4'>
                  <Alert message={error} type="error" />
                </div>
                : null
            }

            <Form
              layout="vertical"
              onFinish={onFinish}
              form={form}
            >
              <Form.Item
                label="Username"
                name="userName"
                rules={[{ required: true, message: 'Input is required' }]}
                validateStatus={errors?.userName.length > 0 ? 'error' : undefined}
                help={errors?.userName.length > 0 ? errors?.userName : undefined}
              >
                <Input
                  onChange={() => {
                    setErrors(prevState => ({
                      ...prevState,
                      userName: '',
                    }))
                  }}
                  placeholder="Enter your desired username"
                />
              </Form.Item>

              <div className='mt-[2.5rem] flex justify-end'>
                <Button
                  onClick={() => {
                    if (!loading) {
                      closeModal()
                    }
                  }}
                  style={{
                    color: '#200E32 !important'
                  }}
                  disabled={loading}
                  className='mr-[0.9rem] custom-white-btn black-text smaller-padding'>

                  Cancel
                </Button>

                <Button
                  disabled={loading}
                  className='custom-primary-two-btn smaller-padding'
                  loading={loading}
                  htmlType='submit'

                >
                  Update
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Updateusername